var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_478_5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 17.5,
    r: 17.5,
    transform: "rotate(-180 21.5 17.5)",
    fill: "white",
    fillOpacity: 0.49,
    shapeRendering: "crispEdges"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_478_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.6237 26.7661L17.6041 17.5033L26.6237 8.23382C27.1212 7.72285 27.1212 6.8909 26.6237 6.37993C26.1262 5.86897 25.316 5.86897 24.8185 6.37993L14 17.4967L24.8249 28.6135C25.3224 29.1244 26.1325 29.1244 26.6301 28.6135C27.1276 28.1025 27.1276 27.2771 26.6237 26.7661Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_478_5",
    x: 0,
    y: 0,
    width: 43,
    height: 43,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_478_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_478_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_478_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 23,
    fill: "white",
    transform: "translate(27 29) rotate(-180)"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDMiIGhlaWdodD0iNDMiIHZpZXdCb3g9IjAgMCA0MyA0MyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgZmlsdGVyPSJ1cmwoI2ZpbHRlcjBfZF80NzhfNSkiPgo8Y2lyY2xlIGN4PSIyMS41IiBjeT0iMTcuNSIgcj0iMTcuNSIgdHJhbnNmb3JtPSJyb3RhdGUoLTE4MCAyMS41IDE3LjUpIiBmaWxsPSJ3aGl0ZSIgZmlsbC1vcGFjaXR5PSIwLjQ5IiBzaGFwZS1yZW5kZXJpbmc9ImNyaXNwRWRnZXMiLz4KPC9nPgo8ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfNDc4XzUpIj4KPHBhdGggZD0iTTI2LjYyMzcgMjYuNzY2MUwxNy42MDQxIDE3LjUwMzNMMjYuNjIzNyA4LjIzMzgyQzI3LjEyMTIgNy43MjI4NSAyNy4xMjEyIDYuODkwOSAyNi42MjM3IDYuMzc5OTNDMjYuMTI2MiA1Ljg2ODk3IDI1LjMxNiA1Ljg2ODk3IDI0LjgxODUgNi4zNzk5M0wxNCAxNy40OTY3TDI0LjgyNDkgMjguNjEzNUMyNS4zMjI0IDI5LjEyNDQgMjYuMTMyNSAyOS4xMjQ0IDI2LjYzMDEgMjguNjEzNUMyNy4xMjc2IDI4LjEwMjUgMjcuMTI3NiAyNy4yNzcxIDI2LjYyMzcgMjYuNzY2MVoiIGZpbGw9IndoaXRlIi8+CjwvZz4KPGRlZnM+CjxmaWx0ZXIgaWQ9ImZpbHRlcjBfZF80NzhfNSIgeD0iMCIgeT0iMCIgd2lkdGg9IjQzIiBoZWlnaHQ9IjQzIiBmaWx0ZXJVbml0cz0idXNlclNwYWNlT25Vc2UiIGNvbG9yLWludGVycG9sYXRpb24tZmlsdGVycz0ic1JHQiI+CjxmZUZsb29kIGZsb29kLW9wYWNpdHk9IjAiIHJlc3VsdD0iQmFja2dyb3VuZEltYWdlRml4Ii8+CjxmZUNvbG9yTWF0cml4IGluPSJTb3VyY2VBbHBoYSIgdHlwZT0ibWF0cml4IiB2YWx1ZXM9IjAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDEyNyAwIiByZXN1bHQ9ImhhcmRBbHBoYSIvPgo8ZmVPZmZzZXQgZHk9IjQiLz4KPGZlR2F1c3NpYW5CbHVyIHN0ZERldmlhdGlvbj0iMiIvPgo8ZmVDb21wb3NpdGUgaW4yPSJoYXJkQWxwaGEiIG9wZXJhdG9yPSJvdXQiLz4KPGZlQ29sb3JNYXRyaXggdHlwZT0ibWF0cml4IiB2YWx1ZXM9IjAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAuMjUgMCIvPgo8ZmVCbGVuZCBtb2RlPSJub3JtYWwiIGluMj0iQmFja2dyb3VuZEltYWdlRml4IiByZXN1bHQ9ImVmZmVjdDFfZHJvcFNoYWRvd180NzhfNSIvPgo8ZmVCbGVuZCBtb2RlPSJub3JtYWwiIGluPSJTb3VyY2VHcmFwaGljIiBpbjI9ImVmZmVjdDFfZHJvcFNoYWRvd180NzhfNSIgcmVzdWx0PSJzaGFwZSIvPgo8L2ZpbHRlcj4KPGNsaXBQYXRoIGlkPSJjbGlwMF80NzhfNSI+CjxyZWN0IHdpZHRoPSIxMyIgaGVpZ2h0PSIyMyIgZmlsbD0id2hpdGUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDI3IDI5KSByb3RhdGUoLTE4MCkiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K";
export { SvgArrowLeft as ReactComponent };